
import { Component, Vue, Inject, Watch } from "vue-property-decorator";
import nyNetwork from "@/api/nyBaseNetwork";
import store from "@/store";

@Component({
    components: {}
})
export default class Index extends Vue {

    onRoutes = "";

    main_height = document.body.offsetHeight - 70;

    created() { }

    mounted() {

    }

    beforeDestroy() {

    }

    /**
     * 菜单激活回调
     * @param key
     * @param keyPath
     */
    selectSide(key: any, keyPath: any) {
        // if (key == "/bigdata") {
        //     let routeData = this.$router.resolve({
        //         //去掉开头防使用index做router的#符
        //         path: "/bigdata".replace("#", "")
        //     });
        //     window.open(routeData.href, "_blank");
        //     return;
        // }
        this.$dzSystem.onRoutes = keyPath;
    }


}
